import React, { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import SpecialCarImage from "assets/svgIcons/CarType/SpecialNeeds";
import MarshalCarImage from "assets/svgIcons/CarType/Marshals";
import BeverageCarImage from "assets/svgIcons/CarType/F&B";
import CarNotUseImage from "assets/svgIcons/CarType/NotInUse";
import CarNotCommunicatingImage from "assets/svgIcons/CarType/NotCommunication";
import CarOutsidePerimeterImage from "assets/svgIcons/CarType/OutsidePerimeter";
import { FaAddressCard } from "react-icons/fa";
import FilterCarIcon from "assets/svgIcons/FilterCarIcon";
import FilterFlagIcon from "assets/svgIcons/FilterFlagIcon";
import FilterShildIcon from "assets/svgIcons/FilterShildIcon";
import FilterDineIcon from "assets/svgIcons/FilterDineIcon";
import FilterBlockIcon from "assets/svgIcons/FilterBlockIcon";
import FilterTagsIcon from "assets/svgIcons/NotCommunicating";
import PinIcon from "assets/svgIcons/MapIcon";
import FindCar from "assets/svgIcons/LocationPointIcon";
import ShareIcon from "assets/svgIcons/ShareIcon";
import TimeFilterIcon from "assets/svgIcons/TimeFilterIcon";
import ChatIcon from "assets/svgIcons/ChatIcon";
import BatteryFilterIcon from "assets/svgIcons/BatteryFilterIcon";
import SearchIcon from "assets/svgIcons/SearchIcon";
import ClickDriveIcon from "assets/svgIcons/ClickToDrive";
import CloseIcon from "../../../../assets/svgIcons/CloseIcon";
import {
  getFeatureSetOption,
  getFeaturesList,
  isUserAdmin,
  isUserSupport,
  carType
} from "../../../../constant";
import {
  TagsContainer,
  SelectTags,
  FilterContainer,
  SubSideNavWrapper,
  SelectTagCar,
  SelectionHeading,
  CarTypeBtnWrapper,
  ConnectedStatesBtnWrapper,
  ClickToDriveInputWrapper,
} from "commonComponents/SideNav/subSectionNav/Map/MapStyled";
import { getCarTrackData } from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import {
  MAP_GLOBAL_STATES,
  COMMON_COMPONENTS_STATES,
  SITEID_GLOBAL_STATE,
  CAR_LOCATION_STATE
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import StyledSlider from "commonComponents/Slider";
import CarIcon from "assets/svgIcons/CarIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import {
  ClickToDriveComponent,
  TagCarsComponent,
} from "./commonFunctionalities/TagCars";
import { MessageWindowComponent } from "./commonFunctionalities/MessageWindow";
import { useFilteredCarsHook } from "customHooks/useFilterData";
import { CircleBtn } from "assets/css/globle";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import SpecialNeedsIcon from "assets/svgIcons/CarType/SpecialNeeds";

export const CarsSection = () => {
  const {
    getCheckedCars,
    showTaggedCar,
    openInfoWindow,
    specificCarTrackHistory,
    showTaggedCarArrayClickToDriveInputValueSetter,
    showClickToDriveWindow,
    enableClickToDriveFeature,
    mapCarsSelectAll,
    fleetCarsGlobalState,
    specialCarsGlobalState,
    memberCarsGlobalState,
    marshalCarsGlobalState,
    beverageCarsGlobalState,
    notInUseCarsGlobalState,
    carsNotCommunicatingGlobalState,
    outsidePerimeterGlobalState,
    mapSideNavTabState,
    displayLocation,
    cometTrailOnHoverGlobalState
  } = useHookstate(MAP_GLOBAL_STATES);

  const { showTagCarsState, showTagCarsFromMapState, showMessageWindowState } =
    useHookstate(COMMON_COMPONENTS_STATES);

  const { carLocationBtn } = useHookstate(CAR_LOCATION_STATE);
  const [lowBatteryState, setlowBatteryState] = useState(false);
  const [criticalBatteryState, setCriticalBatteryState] = useState(false);
  const [lowPaceStatus, setLowPaceStatus] = useState(false);
  const [criticalPaceStatue, setCriticalPaceStatue] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [displayLocationData, setDisplayLocationData] = useState(false);
  const [highlightCar, setHighlightCar] = useState(null);
  const [highlightGpsiCarIds, setHighlightGpsiCarIds] = useState([]);
  const [fleetCars, setFleetCars] = useState(true);
  const [specialCars, setSpecialCars] = useState(true);
  const [marshalCars, setMarshalCars] = useState(true);
  const [beverageCars, setBeverageCars] = useState(true);
  const [notInUseCars, setNotInUseCars] = useState(true);
  const [carsNotCommunicating, setCarsNotCommunicating] = useState(true);

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const dispatch = useDispatch();

  const { getUserRole, siteSettingsData } = useSelector((state) => state.commonReducers) || [];

  const [closeCarSection, setCloseCarSection] = useState(true);
  const enableMemberCar = (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || !getFeatureSetOption(
    siteSettingsData?.Features,
    getFeaturesList().member_cars
  ));
  const [memberCars, setMemberCars] = useState(enableMemberCar);
  const [memberSpecialCars, setMemberSpecialCars] = useState(enableMemberCar);

  const { getSelectedCarsState } = useFilteredCarsHook({
    marshalCars: marshalCars,
    specialCars: specialCars,
    MemberCars: memberCars,
    memberSpecialCars: memberSpecialCars,
    beverageCars: beverageCars,
    fleetCars: fleetCars,
    notInUseCars: notInUseCars,
    notCommunicatingCars: carsNotCommunicating,
    paceWarning: lowPaceStatus,
    paceCritical: criticalPaceStatue,
    batteryWarning: lowBatteryState,
    batteryCritical: criticalBatteryState,
    carLocationBtn: carLocationBtn.get(),
  });

  const { t } = useTranslation();

  useEffect(() => {
    let locationTrackingData = localStorage.getItem("locationTrackingData");
    if (locationTrackingData) {
      locationTrackingData = JSON.parse(locationTrackingData);
      if (
        locationTrackingData.carNumber === null ||
        locationTrackingData.gpsiCarId === null ||
        locationTrackingData.carType === null
      ) {
        dispatch(getCarTrackData([]));
      }
    }
  }, [localStorage.getItem("locationTrackingData")]);

  useEffect(() => {
    if (!getFeatureSetOption(siteSettingsData && siteSettingsData?.Features, getFeaturesList().car_control)) {
      openInfoWindow.set(false);
    }

    let locationTrackingData = localStorage.getItem("locationTrackingData");

    if (locationTrackingData) {
      locationTrackingData = JSON.parse(locationTrackingData);
      showTaggedCar.set(locationTrackingData.carNumber);
      setTagCarOnMap(
        locationTrackingData.carNumber,
        locationTrackingData.gpsiCarId,
        locationTrackingData.carType
      );
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("CarlocalStorageData", JSON.stringify(getCheckedCars.get()));
  }, [getCheckedCars.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    if (showTaggedCar.get() === 0 || showTaggedCar.get() === null) {
      setHighlightCar(showTaggedCar.get());
    } else {
      setHighlightCar(showTaggedCar.get());
    }
  }, [showTaggedCar.get()]);

  useEffect(() => {
    if (localStorage.getItem("TaggedCarsData")) {
      let array = localStorage.getItem("TaggedCarsData").split(",");
      array = array.map((data) => parseInt(data));
      showTaggedCarArrayClickToDriveInputValueSetter.set(array);
    }
  }, []);

  useEffect(() => {
    if (carLocationBtn.get()) {
      specificCarTrackHistory.set(true);
      let locationTrackingData = localStorage.getItem("locationTrackingData");
      locationTrackingData = JSON.parse(locationTrackingData);
      if (locationTrackingData) {
        showTaggedCar.set(locationTrackingData.carNumber);
      }
    } else {
      specificCarTrackHistory.set(false);
      showTaggedCar.set(null);
    }
  }, [carLocationBtn.get()]);

  const carsOption = [
    {
      id: 1,
      labelText: t("Fleet"),
      icons: <CarIcon color="#636f7c" width={18} />,
      name: "fleetCars",
      value: getCheckedCars.get().find((it) => it.carType === carType.normal).isChecked,
      carType: carType.normal,
    },
    {
      id: 2,
      labelText: t("Marshals"),
      icons: <MarshalCarImage />,
      name: "marshalCars",
      value: getCheckedCars.get().find((it) => it.carType === carType.marshal).isChecked,
      carType: carType.marshal,
    },
    {
      id: 3,
      labelText: t("F&B"),
      icons: <BeverageCarImage />,
      name: "beverageCars",
      value: getCheckedCars.get().find((it) => it.carType === carType.bevcart).isChecked,
      carType: carType.bevcart,
    },
    {
      id: 4,
      labelText: t("Special_needs"),
      icons: <SpecialCarImage bg={"#0026AC"} />,
      name: "specialNeedsCars",
      value: getCheckedCars.get().find((it) => it.carType === carType.handicap).isChecked,
      carType: carType.handicap,
    },
    {
      id: 5,
      labelText: t("Not_communicating"),
      icons: <CarNotCommunicatingImage />,
      name: "notCommunicatingCars",
      value: getCheckedCars.get().find((it) => it.carType === carType.notCommunicating).isChecked,
      carType: carType.notCommunicating,
    },
    {
      id: 6,
      labelText: t("NOT_in_use"),
      icons: <CarNotUseImage />,
      name: "notInUseCars",
      value: getCheckedCars.get().find((it) => it.carType === carType.notInUse).isChecked,
      carType: carType.notInUse,
    },
    {
      id: 7,
      labelText: t("Outside_Site_Perimeter"),
      icons: <CarOutsidePerimeterImage />,
      name: "outsidePerimeterCars",
      value: getCheckedCars.get().find((it) => it.carType === carType.outOfService).isChecked,
      carType: carType.outOfService,
    },
    {
      id: 8,
      labelText: t("Member_car"),
      icons: <FaAddressCard />,
      name: "membercar",
      value: getCheckedCars.get().find((it) => it.carType === carType.member).isChecked,
      carType: carType.member,
    }
  ];

  const handleCarsInput = (e, carName, carVisibility, carTrue) => {
    let { checked } = e.target;

    localStorage.setItem("mapCarsSelectAll", true);

    if (checked == undefined) {
      checked = carTrue == true ? false : true;
    }

    if (carVisibility === "selectAllCars") {
      mapCarsSelectAll.set(true);
      fleetCarsGlobalState.set(true);
      specialCarsGlobalState.set(true);
      enableMemberCar && memberCarsGlobalState.set(true);
      marshalCarsGlobalState.set(true);
      beverageCarsGlobalState.set(true);
      notInUseCarsGlobalState.set(true);
      carsNotCommunicatingGlobalState.set(true);
      outsidePerimeterGlobalState.set(true);
      cometTrailOnHoverGlobalState.set(true);
      openInfoWindow.set(true);
      getCheckedCars.set([
        { carName: "fleetCars", carType: carType.normal, isChecked: true },
        { carName: "marshalCars", carType: carType.marshal, isChecked: true },
        { carName: "beverageCars", carType: carType.bevcart, isChecked: true },
        { carName: "specialNeedsCars", carType: carType.handicap, isChecked: true },
        { carName: "memberCars", carType: carType.member, isChecked: true },
        { carName: "notCommunicatingCars", carType: carType.notCommunicating, isChecked: true },
        { carName: "notInUseCars", carType: carType.notInUse, isChecked: true },
        { carName: "outsidePerimeterCars", carType: carType.outOfService, isChecked: true },
        { carName: "cometTrailsOnHover", isChecked: true },
      ]);
    } else if (carVisibility === "deselectAllCars") {
      mapCarsSelectAll.set(false);
      fleetCarsGlobalState.set(false);
      specialCarsGlobalState.set(false);
      memberCarsGlobalState.set(false);
      marshalCarsGlobalState.set(false);
      beverageCarsGlobalState.set(false);
      notInUseCarsGlobalState.set(false);
      carsNotCommunicatingGlobalState.set(false);
      outsidePerimeterGlobalState.set(false);
      cometTrailOnHoverGlobalState.set(false);
      openInfoWindow.set(false);
      getCheckedCars.set([
        { carName: "fleetCars", carType: carType.normal, isChecked: false },
        { carName: "marshalCars", carType: carType.marshal, isChecked: false },
        { carName: "beverageCars", carType: carType.bevcart, isChecked: false },
        { carName: "specialNeedsCars", carType: carType.handicap, isChecked: false },
        { carName: "memberCars", carType: carType.member, isChecked: false },
        { carName: "notCommunicatingCars", carType: carType.notCommunicating, isChecked: false },
        { carName: "notInUseCars", carType: carType.notInUse, isChecked: false },
        { carName: "outsidePerimeterCars", carType: carType.outOfService, isChecked: false },
        { carName: "cometTrailsOnHover", isChecked: false },
      ]);
    } else {
      let data = JSON.parse(JSON.stringify(getCheckedCars.get()));

      data.forEach((it) => {
        if (it.carName === carName) it.isChecked = checked;
      });

      getCheckedCars.set(data);

      if (checked) {
        openInfoWindow.set(true);
      }
    }
  }

  const resetFunction = () => {
    let locationTrackingData = {
      carNumber: null,
      gpsiCarId: null,
      carType: null,
    };
    locationTrackingData = JSON.stringify(locationTrackingData);
    localStorage.setItem("locationTrackingData", locationTrackingData);
    displayLocation.set(false);
    setHighlightCar(null);
    setHighlightGpsiCarIds([]);
    specificCarTrackHistory.set(false);
    showTaggedCar.set(null);
    setSearchInput("");
    setLowPaceStatus(false);
    setlowBatteryState(false);
    setCriticalBatteryState(false);
    setCriticalPaceStatue(false);

    setFleetCars(true);
    setSpecialCars(true);
    enableMemberCar && setMemberCars(true);
    enableMemberCar && setMemberSpecialCars(true);
    setMarshalCars(true);
    setBeverageCars(true);
    setNotInUseCars(true);
    setCarsNotCommunicating(true);
  }

  const handleCarTrack = (carGpsiCarId) => {
    if (carGpsiCarId) {
      const payload = {
        gpsiCarId: carGpsiCarId,
        hoursBack: "72",
      };
      dispatch(COMMON_SERVICES.getCarTrackServices(payload, siteId.get())).then(() => { });
    }
  }

  const setTagCarOnMap = (carNumber, gpsiCarId, carType) => {
    const exist = highlightCar === carNumber;
    const gpsExist = highlightGpsiCarIds.find((item) => item.gpsiCarId === gpsiCarId);

    if (exist && gpsExist) {
      let newGpsData = highlightGpsiCarIds.filter((item) => item.gpsiCarId !== gpsiCarId);
      setHighlightCar(null);
      setHighlightGpsiCarIds(newGpsData);
      let locationTrackingData = {
        carNumber: null,
        gpsiCarId: null,
        carType: null,
      };
      locationTrackingData = JSON.stringify(locationTrackingData);
      localStorage.setItem("locationTrackingData", locationTrackingData);
      specificCarTrackHistory.set(false);
    } else {
      if (carNumber !== null && gpsiCarId !== null && carType !== null) {
        setHighlightCar(carNumber);
        displayLocation.set(true);
        let locationTrackingData = {
          carNumber: carNumber,
          gpsiCarId: gpsiCarId,
          carType: carType,
        };
        locationTrackingData = JSON.stringify(locationTrackingData);
        localStorage.setItem("locationTrackingData", locationTrackingData);

        setHighlightGpsiCarIds([{ gpsiCarId, carType }]);
        specificCarTrackHistory.set(true);
        handleCarTrack(gpsiCarId);
      }
    }
  }

  const findLocation = () => {
    carLocationBtn.set(!carLocationBtn.get());
    localStorage.setItem("carLocationBtn", carLocationBtn.get());
    setFleetCars(true);
    setMarshalCars(true);
    setBeverageCars(true);
    setSpecialCars(true);
    enableMemberCar && setMemberCars(true);
    enableMemberCar && setMemberSpecialCars(true);
    setNotInUseCars(true);
    setCarsNotCommunicating(true);
    setDisplayLocationData(!displayLocationData);
    showTagCarsState.set(false);
    showTagCarsFromMapState.set(false);
    showMessageWindowState.set(false);
    enableClickToDriveFeature.set(false);
    showClickToDriveWindow.set(false);
  }

  const showPopupWindow = (windowType) => {
    if (windowType === "messagebox") {
      showTagCarsState.set(false);
      showTagCarsFromMapState.set(false);
      showMessageWindowState.set(!showMessageWindowState.get());
      carLocationBtn.set(false);
      localStorage.setItem("carLocationBtn", false);
      setDisplayLocationData(false);
      showClickToDriveWindow.set(false);
      enableClickToDriveFeature.set(false);
    } else if (windowType === "tagcar") {
      showMessageWindowState.set(false);
      carLocationBtn.set(false);
      localStorage.setItem("carLocationBtn", false);
      showTagCarsFromMapState.set(!showTagCarsFromMapState.get());
      setDisplayLocationData(false);
      showClickToDriveWindow.set(false);
      enableClickToDriveFeature.set(false);
    } else {
      return <></>;
    }
  }

  const handleClickToDrive = () => {
    enableClickToDriveFeature.set(!enableClickToDriveFeature.get());
    showClickToDriveWindow.set(false);
    showTagCarsState.set(false);
    showMessageWindowState.set(false);
    carLocationBtn.set(false);
    localStorage.setItem("carLocationBtn", false);
  }

  const shouldSelectAllBeActive = () => {
    return fleetCarsGlobalState.get() &&
                    specialCarsGlobalState.get() &&
                    (!enableMemberCar || memberCarsGlobalState.get()) &&
                    marshalCarsGlobalState.get() &&
                    beverageCarsGlobalState.get() &&
                    notInUseCarsGlobalState.get() &&
                    carsNotCommunicatingGlobalState.get() &&
                    outsidePerimeterGlobalState.get() &&
                    cometTrailOnHoverGlobalState.get();
  }

  const shouldDeselectAllBeActive = () => {
    return !fleetCarsGlobalState.get() &&
                    !specialCarsGlobalState.get() &&
                    !memberCarsGlobalState.get() &&
                    !marshalCarsGlobalState.get() &&
                    !beverageCarsGlobalState.get() &&
                    !notInUseCarsGlobalState.get() &&
                    !carsNotCommunicatingGlobalState.get() &&
                    !outsidePerimeterGlobalState.get() &&
                    !cometTrailOnHoverGlobalState.get();
  }

  return (
    <div>
      <SubSideNavWrapper>
        {closeCarSection && (
          <>
            <div className="close-icon-wrapper-mobile">
              <button
                onClick={() => {
                  setCloseCarSection(!closeCarSection);
                  mapSideNavTabState.set("");
                }}
              >
                <CloseIcon />
              </button>
            </div>
            <SelectTags>
              <Button className={shouldSelectAllBeActive() ? "active" : ""}
                variant="outlined"
                onClick={(e) => handleCarsInput(e, null, "selectAllCars", null)}
              >
                {t("Select_all")}
              </Button>
              <Button className={shouldDeselectAllBeActive() ? "active" : ""}
                variant="outlined"
                onClick={(e) =>
                  handleCarsInput(e, null, "deselectAllCars", null)
                }
              >
                {t("Deselect_all")}
              </Button>
            </SelectTags>
            <SelectionHeading>{t("Car_type")}</SelectionHeading>
            <FilterContainer>
              <CarTypeBtnWrapper>
                <button className={fleetCarsGlobalState.get() ? "active" : ""}
                  onClick={(e) => {
                    handleCarsInput(e, carsOption[0].name, null, carsOption[0].value);
                    fleetCarsGlobalState.set(!fleetCarsGlobalState.get());
                  }}
                >
                  {carsOption[0].icons}
                  {carsOption[0].labelText}
                </button>

                <button className={marshalCarsGlobalState.get() ? "active" : ""}
                  onClick={(e) => {
                    handleCarsInput(e, carsOption[1].name, null, carsOption[1].value);
                    marshalCarsGlobalState.set(!marshalCarsGlobalState.get());
                  }}
                >
                  {carsOption[1].icons}
                  {carsOption[1].labelText}
                </button>

                <button className={beverageCarsGlobalState.get() ? "active" : ""}
                  onClick={(e) => {
                    handleCarsInput(e, carsOption[2].name, null, carsOption[2].value);
                    beverageCarsGlobalState.set(!beverageCarsGlobalState.get());
                  }}
                >
                  {carsOption[2].icons}
                  {carsOption[2].labelText}
                </button>

                <button className={specialCarsGlobalState.get() ? "active" : ""}
                  onClick={(e) => {
                    handleCarsInput(e, carsOption[3].name, null, carsOption[3].value);
                    specialCarsGlobalState.set(!specialCarsGlobalState.get());
                  }}
                >
                  {carsOption[3].icons}
                  {carsOption[3].labelText}
                </button>
                {enableMemberCar &&
                  <button className={memberCarsGlobalState.get() ? "active" : ""}
                    onClick={(e) => {
                      handleCarsInput(e, carsOption[7].name, null, carsOption[7].value);
                      memberCarsGlobalState.set(!memberCarsGlobalState.get());
                    }}
                  >
                    {carsOption[7].icons}
                    {carsOption[7].labelText}
                  </button>}
              </CarTypeBtnWrapper>
              <SelectionHeading>{t("Connected_States")}</SelectionHeading>
              <ConnectedStatesBtnWrapper>
                <button className={carsNotCommunicatingGlobalState.get() ? "active" : ""}
                  onClick={(e) => {
                    handleCarsInput(e, carsOption[4].name, null, carsOption[4].value);
                    carsNotCommunicatingGlobalState.set(!carsNotCommunicatingGlobalState.get());
                  }}
                >
                  {carsOption[4].icons}
                  {carsOption[4].labelText}
                </button>
                <button
                  className={notInUseCarsGlobalState.get() ? "active" : ""}
                  onClick={(e) => {
                    handleCarsInput(e, carsOption[5].name, null, carsOption[5].value);
                    notInUseCarsGlobalState.set(!notInUseCarsGlobalState.get());
                  }}
                >
                  {carsOption[5].icons}
                  {carsOption[5].labelText}
                </button>
                <button className={outsidePerimeterGlobalState.get() ? "active" : ""}
                  onClick={(e) => {
                    handleCarsInput(e, carsOption[6].name, null, carsOption[6].value);
                    outsidePerimeterGlobalState.set(!outsidePerimeterGlobalState.get());
                  }}
                >
                  {carsOption[6].icons}
                  {carsOption[6].labelText}
                </button>

              </ConnectedStatesBtnWrapper>
              <SelectionHeading>{t("Other")}</SelectionHeading>
              <ConnectedStatesBtnWrapper>
                <button
                  className={cometTrailOnHoverGlobalState.get() ? "active" : ""}
                  onClick={() => { cometTrailOnHoverGlobalState.set((prevState) => !prevState) }}
                >
                  <PinIcon color={cometTrailOnHoverGlobalState.get() ? "var(--theme-text)" : "#333433"} />
                  {t("Comet_trails_on_hover")}
                </button>
                {window.innerWidth > 850 &&
                  (
                    isUserAdmin(getUserRole?.Role) ||
                    isUserSupport(getUserRole?.Role)
                  ) && (
                    <button
                      style={{ background: "var(--admin-tab-bg)" }}
                      className={enableClickToDriveFeature.get() ? "active" : ""}
                      onClick={handleClickToDrive}
                    >
                      <ClickDriveIcon />
                      {t("Click_To_Drive_(emulation)")}
                    </button>
                  )}
              </ConnectedStatesBtnWrapper>
            </FilterContainer>
            {enableClickToDriveFeature.get() && (
              <ClickToDriveInputWrapper>
                <input
                  type="text"
                  className="input-box"
                  value={
                    showTaggedCarArrayClickToDriveInputValueSetter.get()
                      ? showTaggedCarArrayClickToDriveInputValueSetter.get()
                      : ""
                  }
                  onFocus={() => {
                    carLocationBtn.set(false);
                    localStorage.setItem("carLocationBtn", false);
                    showTagCarsState.set(false);
                    showMessageWindowState.set(false);
                    showClickToDriveWindow.set(true);
                    setDisplayLocationData(false);
                  }}
                  readOnly
                />
              </ClickToDriveInputWrapper>
            )}
            <TagsContainer>
              <Tooltip title={t("Location")} placement="top" arrow>
                <button
                  className={
                    carLocationBtn.get() &&
                      !showClickToDriveWindow.get() &&
                      !enableClickToDriveFeature.get()
                      ? "active"
                      : ""
                  }
                  onClick={(e) => {
                    findLocation(e);
                  }}
                  disabled={
                    getFeatureSetOption(
                      siteSettingsData && siteSettingsData.Features,
                      getFeaturesList().real_time_tracking
                    ) && !(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))
                  }
                >
                  <ShareIcon
                    color={
                      displayLocationData &&
                        carLocationBtn.get() &&
                        !showClickToDriveWindow.get() &&
                        !enableClickToDriveFeature.get()
                        ? "var(--theme-text)"
                        : "var(--text-primary)"
                    }
                  />
                </button>
              </Tooltip>

              <Tooltip title={t("Messages")} placement="top" arrow>
                <button
                  className={showMessageWindowState.get() ? "active" : ""}
                  onClick={() => showPopupWindow("messagebox")}
                  disabled={
                    getFeatureSetOption(
                      siteSettingsData && siteSettingsData.Features,
                      getFeaturesList().real_time_tracking
                    ) && !(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))
                  }
                >
                  <ChatIcon
                    color={
                      showMessageWindowState.get()
                        ? "var(--theme-text)"
                        : "var(--text-primary)"
                    }
                  />
                </button>
              </Tooltip>

              <Tooltip title={t("Find_car")} placement="top" arrow>
                <button
                  onClick={() => showPopupWindow("tagcar")}
                  className={showTagCarsFromMapState.get() ? "active" : ""}
                  disabled={
                    getFeatureSetOption(
                      siteSettingsData && siteSettingsData.Features,
                      getFeaturesList().real_time_tracking
                    ) && !(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))
                  }
                >
                  <FindCar color="#1D1D1D" width={12} height={16.69} />
                </button>
              </Tooltip>
            </TagsContainer>{" "}
          </>
        )}
      </SubSideNavWrapper>

      {showClickToDriveWindow.get() &&
        !showTagCarsState.get() &&
        !showMessageWindowState.get() &&
        !carLocationBtn.get() ? (
        <ClickToDriveComponent />
      ) : (
        <></>
      )}

      {showTagCarsFromMapState.get() &&
        !showClickToDriveWindow.get() &&
        !enableClickToDriveFeature.get() &&
        !showMessageWindowState.get() &&
        !carLocationBtn.get() ? (
        <TagCarsComponent />
      ) : (
        <></>
      )}

      {showMessageWindowState.get() &&
        !showTagCarsState.get() &&
        !showClickToDriveWindow.get() &&
        !enableClickToDriveFeature.get() &&
        !carLocationBtn.get() ? (
        <MessageWindowComponent />
      ) : (
        <></>
      )}

      {carLocationBtn.get() &&
        !showClickToDriveWindow.get() &&
        !enableClickToDriveFeature.get() ? (
        <SelectTagCar>
          <div className="inner-wrapper">
            <div className="box-heading">
              <h5>{t("Location")}</h5>
              <div className="close-icon-wrapper-mobile">
                <CloseIcon
                  onClick={() => findLocation()}
                  width={22}
                  height={22}
                />
              </div>
            </div>

            <StyledSlider />
            <div className="filter">
              <p>{t("Filters")}</p>
              <div>
                <Tooltip title={t("Cars_Pace_Warning")} placement="top" arrow>
                  <button onClick={(e) => setLowPaceStatus(!lowPaceStatus)}>
                    <TimeFilterIcon
                      bg={
                        lowPaceStatus
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color="#FFE500"
                      stroke={
                        lowPaceStatus
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip title={t("Cars_Pace_Critical")} placement="top" arrow>
                  <button
                    onClick={(e) => setCriticalPaceStatue(!criticalPaceStatue)}
                  >
                    <TimeFilterIcon
                      bg={
                        criticalPaceStatue
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color="#FA3C30"
                      stroke={
                        criticalPaceStatue
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip
                  title={t("Cars_Battery_Warning")}
                  placement="top"
                  arrow
                >
                  <button onClick={(e) => setlowBatteryState(!lowBatteryState)}>
                    <BatteryFilterIcon
                      bg={
                        lowBatteryState
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color="#FFE500"
                      stroke={
                        lowBatteryState
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
                <Tooltip
                  title={t("Cars_Battery_Critical")}
                  placement="top"
                  arrow
                >
                  <button
                    onClick={(e) =>
                      setCriticalBatteryState(!criticalBatteryState)
                    }
                  >
                    <BatteryFilterIcon
                      bg={
                        criticalBatteryState
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color="#FA3C30"
                      stroke={
                        criticalBatteryState
                          ? "var(--theme-background)"
                          : "var(--side-nav-btn-border-color)"
                      }
                    />
                  </button>
                </Tooltip>
              </div>
            </div>
            <div className="white-filter">
              <Tooltip title={t("Fleet_cars")} placement="top" arrow>
                <button
                  onClick={() => {
                    setFleetCars(!fleetCars);
                  }}
                >
                  <FilterCarIcon
                    bgcolor={
                      fleetCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={
                      fleetCars
                        ? "var(--input-background)"
                        : "var(--text-secondary)"
                    }
                    border={fleetCars ? "#FFE500" : "#707374"}
                  />
                </button>
              </Tooltip>
              <Tooltip title={t("Marshal_cars")} placement="top" arrow>
                <button
                  onClick={() => {
                    setMarshalCars(!marshalCars);
                  }}
                >
                  {" "}
                  <FilterShildIcon
                    bgcolor={
                      marshalCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={marshalCars ? "var(--input-background)" : "#49B3E0"}
                    border={
                      marshalCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"
                    }
                  />
                </button>
              </Tooltip>
              <Tooltip title={t("Beverage_cars")} placement="top" arrow>
                <button
                  onClick={() => {
                    setBeverageCars(!beverageCars);
                  }}
                >
                  <FilterDineIcon
                    bgcolor={
                      beverageCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={beverageCars ? "var(--input-background)" : "#229D08"}
                    border={
                      beverageCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"
                    }
                  />
                </button>
              </Tooltip>
              <Tooltip title={t("Special_needs_cars")} placement="top" arrow>
                <button
                  onClick={() => {
                    setSpecialCars(!specialCars);
                  }}
                >
                  <FilterFlagIcon
                    bgcolor={
                      specialCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={specialCars ? "var(--input-background)" : "#0026AC"}
                    border={
                      specialCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"
                    }
                  />
                </button>
              </Tooltip>
              {enableMemberCar && <><Tooltip title={t("Member_car")} placement="top" arrow>
                <button
                  onClick={() => {
                    setMemberCars(!memberCars);
                  }}
                >
                  <MembercarIcon
                    width={30}
                    height={30}
                    stroke={memberCars
                      ? "var(--theme-background)"
                      : "var(--side-nav-btn-border-color)"}
                    bg={
                      memberCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={memberCars ? "var(--input-background)" : "#00A000"}
                  />
                </button>
              </Tooltip><Tooltip title={t("Member_/_Special_Needs")} placement="top" arrow>
                  <button
                    onClick={() => {
                      setMemberSpecialCars(!memberSpecialCars);
                    }}
                  >
                    <div style={{ display: "inline-flex", gap: 1 }}> <MembercarIcon
                      width={30}
                      height={30}
                      stroke={memberSpecialCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"}
                      bg={
                        memberSpecialCars
                          ? "var(--theme-background)"
                          : "var(--input-background)"
                      }
                      color={memberSpecialCars ? "var(--input-background)" : "#00A000"}
                    />
                      <SpecialNeedsIcon width={20} height={30}
                        bg={
                          memberSpecialCars
                            ? "var(--theme-background)"
                            : "#0026AC"
                        }
                      />
                    </div>
                  </button>
                </Tooltip></>}
              <Tooltip title={t("Cars_not_in_use")} placement="top" arrow>
                <button
                  onClick={() => {
                    setNotInUseCars(!notInUseCars);
                  }}
                >
                  <FilterBlockIcon
                    bgcolor={
                      notInUseCars
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={notInUseCars ? "var(--input-background)" : "#FA3C30"}
                    border={
                      notInUseCars
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"
                    }
                  />
                </button>
              </Tooltip>
              <Tooltip
                title={t("Cars_not_communicating")}
                placement="top"
                arrow
              >
                <button
                  className={carsNotCommunicating ? "active not-com" : " not-com"}
                  onClick={() => {
                    setCarsNotCommunicating(!carsNotCommunicating);
                  }}
                >
                  <FilterTagsIcon
                    bgcolor={
                      carsNotCommunicating
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                    color={
                      carsNotCommunicating
                        ? "var(--input-background)"
                        : "#3134EB"
                    }
                    border={
                      carsNotCommunicating
                        ? "var(--theme-background)"
                        : "var(--side-nav-btn-border-color)"
                    }
                    fill={
                      carsNotCommunicating
                        ? "var(--theme-background)"
                        : "var(--input-background)"
                    }
                  />
                </button>
              </Tooltip>
            </div>
            <div className="search-wrapper">
              <input
                placeholder={t("Search_car_no")}
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
              <SearchIcon />
            </div>
            <div className="car-selection">
              <div className="car-number">
                {getSelectedCarsState.get() &&
                  getSelectedCarsState.get().length !== 0 ? (
                  getSelectedCarsState
                    .get()
                    .filter((item) => {
                      if (searchInput === "") {
                        return item.Car.CarNumber;
                      } else if (
                        item.Car.CarNumber.toString()
                          .toLowerCase()
                          .includes(searchInput.toLowerCase())
                      ) {
                        return item.Car.CarNumber;
                      }
                    })
                    .sort((a, b) => a.Car.CarNumber - b.Car.CarNumber)
                    .map((item, index) => (
                      <button
                        key={index}
                        variant="contained"
                        className={
                          showTaggedCar.get() === item.Car.CarNumber
                            ? "active"
                            : ""
                        }
                        onClick={() => {
                          if (
                            showTaggedCar.get() &&
                            showTaggedCar.get() === item.Car.CarNumber
                          ) {
                            showTaggedCar.set(null);
                            setTagCarOnMap(null, null, null);
                            let locationTrackingData = {
                              carNumber: null,
                              gpsiCarId: null,
                              carType: null,
                            };
                            locationTrackingData =
                              JSON.stringify(locationTrackingData);
                            localStorage.setItem(
                              "locationTrackingData",
                              locationTrackingData
                            );
                            specificCarTrackHistory.set(false);
                          } else {
                            showTaggedCar.set(item.Car.CarNumber);
                            setTagCarOnMap(
                              item.Car.CarNumber,
                              item.Car.GpsiCarId,
                              item.Car.CarType
                            );
                            specificCarTrackHistory.set(true);
                          }
                        }}
                      >
                        {item.Car.CarNumber}
                      </button>
                    ))
                ) : (
                  <p>No car number found</p>
                )}
              </div>
              <div className="reset-section">
                <div className="action-wrapper">
                  <CircleBtn onClick={resetFunction} className="send-btn">
                    {t("Reset")}
                  </CircleBtn>
                </div>
                {/* 
                ) : (
                  <></>
                )}*/}
              </div>
            </div>
          </div>
        </SelectTagCar>
      ) : (
        <></>
      )}
    </div>
  );
};
